export default __webpack_public_path__ + "static/2021_nyr_20447_0001_001_beeple_everydays_the_first_5000_days034733_-198bcc63a96b53935d70097743650fbf.jpg";